module.exports = __webpack_public_path__ + "img/pin-red-diamond.1ad7e555.png";